import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NasModelModule } from '@sama/ng-app-state';
import { ImageAnnotationModule } from '../../outputs/annotation/image-annotation/image-annotation.module';
import { PointCloudModule } from '../../outputs/annotation/point-cloud/point-cloud.module';
import { VideoModule } from '../../outputs/annotation/video/video.module';
import { NestableOutputsModule } from '../../outputs/nestable/nestable-outputs.module';
import { SharedModule } from '../../shared/shared.module';
import { IndividualFieldScoresComponent } from './individual-field-scores.component';
import { NakedOutputComponent } from './naked-output.component';
import { OutputWarningsComponent } from './output-warnings.component';

const exportedComponents = [
  IndividualFieldScoresComponent,
  NakedOutputComponent,
  OutputWarningsComponent,
];

@NgModule({
  imports: [
    CommonModule,
    ImageAnnotationModule,
    FontAwesomeModule,
    MatButtonModule,
    MatTooltipModule,
    NasModelModule,
    NestableOutputsModule,
    PointCloudModule,
    SharedModule,
    VideoModule,
    MatButtonToggleModule,
  ],
  declarations: [exportedComponents],
  exports: [exportedComponents],
})
export class OutputsModule {}
